<template>
  <v-stepper v-model="e1">
<h1>Merchant View</h1>
  <v-stepper-header>
    <v-stepper-step :complete="e1 > 1" step="1">Accept Documents </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step :complete="e1 > 2" step="2">Signatures </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step :complete="e1 > 3" step="3">Submit Documents</v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step step="5">Completion</v-stepper-step>
  </v-stepper-header>

  <v-stepper-items>
    <v-stepper-content step="1">
      <v-card
        class="mb-5"
        color="grey lighten-1"
      >
    Lits/Review all documents


    </v-card>

      <v-btn
        color="purple"
        @click="e1 = 2"
      >
        Continue
      </v-btn>

      <v-btn flat>Cancel</v-btn>
    </v-stepper-content>

    <v-stepper-content step="2">
      <v-card
        class="mb-5"
        color="grey lighten-1"
      >


            Company directors/ shareholders
            First name
            Last name
            Date of birth
            Address
            Nationality
            Identity document (upload) : type, number
            Email address
            Telephone
            Gender
            Number of shares
            Type shareholder/director (could be both)



    </v-card>

      <v-btn
        color="purple"
        @click="e1 = 3"
      >
        Continue
      </v-btn>

      <v-btn flat>Cancel</v-btn>
    </v-stepper-content>

    <v-stepper-content step="3">
      <v-card
        class="mb-5"
        color="grey lighten-1"
        height="200px"
      >
      Task 2 : Signatures

      Links will be sent to all directors and shareholders. Some directors will also be shareholders.
    </v-card>

      <v-btn
        color="purple"
        @click="e1 = 1"
      >
        Continue
      </v-btn>

      <v-btn flat color="purple">Cancel</v-btn>
    </v-stepper-content>
    <v-stepper-content step="4">
      <v-card
        class="mb-5"
        color="grey lighten-1"
        height="200px"
      >
      Task 2 : Signatures

      Links will be sent to all directors and shareholders. Some directors will also be shareholders.
    </v-card>

      <v-btn
        color="purple"
        @click="e1 = 1"
      >
        Continue
      </v-btn>

      <v-btn flat color="purple">Cancel</v-btn>
    </v-stepper-content>
  </v-stepper-items>
</v-stepper>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('users');

  export default {
    data: () => ({
      e1: 0
    }),
    methods: {

    },
    mounted() {
      // this.$validator.localize('en', this.dictionary);
    }
  }
</script>
